import { useMemo } from 'react';
import { Capability } from 'homey-lib/webpack/index.js';

import { DeviceCapability } from '../config/DeviceCapability';
import { zoneActivityCapabilities } from '../config/zoneActivityCapabilities';

import { useCapabilityValues } from '../store/devices/useCapabilityValues';

export function useSensorState({ deviceId, capabilitiesObj }) {
  const capabilityIds = useMemo(() => {
    if (capabilitiesObj == null) {
      return [];
    }

    const result = [];

    for (const capabilityObj of Object.values(capabilitiesObj)) {
      if (capabilityObj.id.startsWith(`${DeviceCapability.AlarmBattery}`)) {
        continue;
      }

      if (capabilityObj.id.startsWith('alarm_') === false) {
        continue;
      }

      result.push(capabilityObj.id);
    }

    return result;
  }, [capabilitiesObj]);

  const [values] = useCapabilityValues({
    deviceId: deviceId,
    capabilityIds: capabilityIds,
  });

  const hasAlarm = useMemo(() => {
    return getHasAlarm(values);
  }, [values]);

  const hasOnlyZoneActivityAlarm = useMemo(() => {
    return getHasOnlyZoneActivityAlarm(values);
  }, [values]);

  return { values, hasAlarm, hasOnlyZoneActivityAlarm };
}

function getHasAlarm(values) {
  return Object.entries(values).some(([capabilityId, capabilityValue]) => {
    if (capabilityId.startsWith('alarm_')) {
      return capabilityValue === true;
    }

    return false;
  });
}

function getHasOnlyZoneActivityAlarm(values) {
  // If we have a zone activity capability and the zone activity is not disabled,
  // we set the component to 'zoneActivity'. We won't get here if there is already
  // an alarm capability also we continue the loop to search for an alarm capability
  let hasOnlyZoneActivityAlarm = false;

  for (const [valueKey, value] of Object.entries(values)) {
    if (zoneActivityCapabilities.has(valueKey) && value === true) {
      hasOnlyZoneActivityAlarm = true;
      continue;
    }

    if (Capability.getBaseId(valueKey).startsWith('alarm_') && value === true) {
      hasOnlyZoneActivityAlarm = false;
      break;
    }
  }

  return hasOnlyZoneActivityAlarm;
}
